// extracted by mini-css-extract-plugin
export var inlineLink = "_8x-0";
export var inlineLinkButton = "_8x-1";